import { Component } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { EqualsValidator } from '../../../common/validators/equals-validator';
import { ComponentWithForm } from '../abstract-classes/component-with-form';

import { ConfirmWithInputInterface } from './confirm-with-input-interface';

@Component({
  selector: 'app-confirm-with-input',
  templateUrl: './confirm-with-input.component.html',
  styleUrls: ['./confirm-with-input.component.css'],
})
export class ConfirmWithInputComponent extends ComponentWithForm {
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  controlNameConfirmedStr = 'confirmationString';

  public data: ConfirmWithInputInterface;

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Lifecycle
  /////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    public ref: DynamicDialogRef,
    dialogConfig: DynamicDialogConfig,
    private formBuilder: UntypedFormBuilder,
  ) {
    super();
    this.data = dialogConfig.data;
  }

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Define Form
  /////////////////////////////////////////////////////////////////////////////////////////////

  protected defineForm() {
    // Init Form
    const formConfig = {} as any;
    formConfig[this.controlNameConfirmedStr] = [
      '',
      [Validators.required, EqualsValidator.equalsValidator(this.data.requiredConfirmationString)],
    ];

    this.form = this.formBuilder.group(formConfig);
  }

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Form Field Getters
  /////////////////////////////////////////////////////////////////////////////////////////////

  get confirmationString(): AbstractControl | null {
    return this.form.get(this.controlNameConfirmedStr);
  }

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Buttons
  /////////////////////////////////////////////////////////////////////////////////////////////

  confirm() {
    this.ref.close(true);
  }

  cancel() {
    this.ref.close(false);
  }
}
